export default "/_next/static/images/7a38968dbad2951f226cc95be640b966.jpg";